<div fxLayout="row" fxLayoutGap="10px" style="margin: 10px;  height: calc(100svh - 90px);">
  <div fxLayout="column" fxFlex="1 1 700px" (click)="closeSidenavCheck($event)">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="header-card">
      <div class="main-title-div bt-headline">My Stores</div>

      @if (hasMultiStoreAccess()) {
        <button matButton="filled" (click)="sidenav.toggle()">
          <span class="bt-lh-1">Stores</span>
          <mat-icon iconPositionEnd>{{ sidenav.opened ? 'close' : 'add' }}</mat-icon>
        </button>
      }
    </div>

    @if (homeStore()) {
      <div class="store-card-wrapper homestore">
        <div class="pinnedstore-card" [ngClass]="homeStore().id === selectedStore?.id ? 'store-selected' : ''" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" (click)="selectStore(homeStore())">
          <div class="truncate-container" fxLayout="column" fxLayoutAlign="space-between start" fxFlex="initial" fxLayoutGap="8px">
            <div class="store-title-div bt-headline bt-regular truncate-text"><a routerLink="../stores/{{homeStore().id}}"> {{ homeStore().name }}</a>
            </div>
            <div class="store-details-div bt-detail truncate-text">
              <span class="bt-semibold">{{ homeStore().organization?.name }}</span> • {{ homeStore().address }}
            </div>
          </div>
          <div fxLayout="column" fxLayoutAlign="space-between end" fxLayoutGap="2px">
            <div class="store-total-tasks pinned bt-count bt-bold">{{ homeStore()?.activeTaskCount ? homeStore().activeTaskCount : '0' }}</div>
            <div class="store-details-div pinned bt-detail">Open Tasks</div>
          </div>
        </div>
        <div class="store-actions">
          <button mat-icon-button routerLink="../stores/{{homeStore().id}}">
            <mat-icon svgIcon="store"></mat-icon>
          </button>
        </div>
        <div class="home-icon">
          <mat-icon svgIcon="home"></mat-icon>
        </div>
      </div>
    }

    @if (showUserMessage()) {
      <div class="store-card-wrapper">
        <div class="placeholder-card bt-headline-small" fxLayout="column" fxLayoutAlign="center center">
          <span>No Home Store Set. Please contact your manager.</span>
        </div>
      </div>
    }

    @if (showMultiMessage()) {
      <div class="store-card-wrapper">
        <div class="placeholder-card" fxLayoutAlign="space-between center" fxLayoutGap="10px">
          <div class="bt-headline-small">My Stores gives you quick access to your most-used
            locations. Add a store to get started.
          </div>
          <button matButton class="main-btn-text bt-button-text" (click)="sidenav.toggle()">
            <span class="bt-lh-1 no-wrap">Add a Store</span>
            <mat-icon iconPositionEnd>{{ sidenav.opened ? 'close' : 'add' }}</mat-icon>
          </button>
        </div>
      </div>
    }

    @if (hasMultiStoreAccess()) {
      <mat-table #table [dataSource]="dataTable" recycleRows class="pinned-stores-table" style="overflow: scroll">
        <ng-container matColumnDef="name">
          <div class="store-card-wrapper" *matCellDef="let store">
            <div class="pinnedstore-card" [ngClass]="store.id === selectedStore?.id ? 'store-selected' : ''" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" (click)="selectStore(store)">
              <div class="truncate-container" fxLayout="column" fxLayoutAlign="space-between start" fxFlex="initial" fxLayoutGap="8px">
                <div class="store-title-div bt-headline bt-regular truncate-text"><a routerLink="../stores/{{store.id}}">{{ store.name }}</a></div>
                <div class="store-details-div bt-detail truncate-text">
                  <span class="bt-semibold">{{ store.organization?.name }}</span> • {{ store.address }}
                </div>
              </div>
              <div fxLayout="column" fxLayoutAlign="space-between end" fxLayoutGap="2px">
                <div class="store-total-tasks pinned bt-count bt-bold">{{ store?.activeTaskCount ? store.activeTaskCount : '0' }}</div>
                <div class="store-details-div pinned bt-detail">Open Tasks</div>
              </div>
            </div>
            <div class="store-actions">
              <button mat-icon-button routerLink="../stores/{{store.id}}">
                <mat-icon svgIcon="store"></mat-icon>
              </button>
            </div>
          </div>
        </ng-container>
        <mat-row class="pinned-stores-table-row" *matRowDef="let row; columns: dataTable.displayedColumns"></mat-row>
      </mat-table>
    }
  </div>

  <div fxLayout="column" fxLayoutGap="20px" fxFlex="1 1 100%" class="sidenav-wrapper">
    <mat-sidenav-container>
      <mat-sidenav #sidenav [mode]="'over'">
        <badger-portal-stores-edit></badger-portal-stores-edit>
      </mat-sidenav>

      <mat-sidenav-content class="sidenav-map-wrapper">
        <button matMiniFab class="main-add-stores main-btn-text bt-button-text" (click)="fitMapToMarkers()">
          <mat-icon>crop_free</mat-icon>
        </button>

        @if (displayMap()) {
          <google-map #homeStoresMap [options]="mapOptions()" [zoom]="zoom()" class="homeStoreMap" height="100%" width="100%" (mapInitialized)="onMapInitialized()" (boundsChanged)="onBoundsChanged()">
            @for (storeMarker of storeMarkers(); track storeMarker) {
              @if (storeMarker.store.hasLocationData()) {
                <map-advanced-marker #markerRef="mapAdvancedMarker" [position]="{lat: storeMarker.store.latitude , lng: storeMarker.store.longitude }" [title]="storeMarker.store.name" [content]="storeMarker.pinElement" [options]="{ gmpClickable: true }" [zIndex]="storeMarker.zIndex" (markerInitialized)="onMarkerInit($event, storeMarker.store)"/>
              }
            }
          </google-map>
        }
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>
